module.exports = __webpack_public_path__ + "img/ritinha1.09375e88.png";